import { createReduxAsyncThunk } from 'shared/utils';

import dataSources from 'dataSources';

import { STATIONS_STATE } from '../../constants';

import { FavouriteStation } from '../../types';

export const getFavouriteStations = createReduxAsyncThunk<{ favouriteStations: FavouriteStation[] }>(
  `${STATIONS_STATE}/getFavouriteStations`,
  async () => {
    return await dataSources.stationsWithPrices.getFavouriteStations();
  }
);
